// Opens `a[data-window-open]` links with `window.open`: only a tab opened by script can close itself.
export function initWindowOpen() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[data-window-open]");
    if (!link) return;

    event.preventDefault();
    window.open(link.href);
  });
}
